const constants = {
  propulsionTypeCodes: {
    SteamTurbine: "STM",
    DieselElectric: "DSE",
    LiquidFuelEngine: "LFE",
    GasEngine: "GSE",
    Dual: "DUL",
    DieselElectricDual: "DED",
  },
  iceTypeCodes: {
    IC: "IC",
    IB: "IB",
    IA: "IA",
    IASuper: "IA Super",
    None: "NONE",
  },
  shipTypeCodes: {
    BulkCarrier: "BLC",
    GasCarrier: "GSC",
    Tanker: "TNK",
    ContainerShips: "CNS",
    GeneralCargoVessels: "GCV",
    RefrigeratedCargoCarrier: "RCC",
    CombinationCarrier: "CMC",
    LNG: "LNG",
    ROROCargo: "RCS",
    RORO: "RRS",
    ROPAX: "RPV",
    Passengers: "PSV",
  },
  powerLimitTypeCodes: {
    Overridable: "OVR",
    NonOverridableOther: "NOOT",
    NonOverridablePropellerRetrofit: "NOPR",
  },
  shipPartsElements: [
    "AuxiliaryEngineEmissions",
    "AuxiliaryEngineEnergySavings",
    "MainEngineEmissions",
    "MainEngineEnergySavings",
    "PowerTakeIns",
  ],
};

module.exports = constants;
